import { ParsedType } from '~/redux/api/transformers/utils';
import { UpdateExternalUserRequest } from '~/redux/api/types/rolodex/user';
import { rolodex } from '~/services/serviceInstances';

type updateExternalUserRequest = ParsedType<UpdateExternalUserRequest>;
type requestParams = {
  userId: string | number;
  body: updateExternalUserRequest;
};

export const updateWorkdayUser = async ({ userId, body }: requestParams) => {
  await rolodex.put<UpdateExternalUserRequest>(`/user/workday/${userId}`, {
    role_uuid: body.roleUuid,
    pilot_department_ids: body.pilotDepartmentIds,
  });
};
